import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5938d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = {
  class: "ion-align-items-center ion-justify-content-between",
  style: {"display":"flex"}
}

import {onMounted, ref, watch} from "vue";
import {
	IonAvatar,
	IonBadge,
	IonItem,
	IonLabel,
	IonList,
	IonListHeader,
	IonIcon,
	IonImg,
	IonProgressBar,
	toastController,
	IonInfiniteScroll,
	IonInfiniteScrollContent, InfiniteScrollCustomEvent,
} from '@ionic/vue';
import * as icons from 'ionicons/icons';
import {ChallengeHighscoreEntry} from "@/mobipoints/challenge/challenge/highscore/highscore_entry.type";
import {MobiPointsApiChallenge} from "@/mobipoints/api/challenge";
import useChallengeFactory from "@/composable/useChallengeFactory";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {AxiosError, AxiosResponse} from "axios";
import useUserRepository from "@/components/user/UserRepository.vue";
import useChallenge from "@/composable/useChallenge";



export default /*#__PURE__*/_defineComponent({
  __name: 'ChallengeHighscore',
  props: {
	uuid: {
		type: String,
		required: true
	}
},
  setup(__props) {

const props = __props;

const {getUserEmail} = useUserRepository();

const {getChallengeFactory} = useChallengeFactory();

const challengeFacade = useChallenge();

const highscoreList = ref<ChallengeHighscoreEntry[]>([]);

const currentHighscoreCount = ref<number>(25);

const loadHighscore = async function (uuid: string) {
	let response: AxiosResponse | null = null;

	try {
		response = await MobiPointsApiChallenge.getHighscore(uuid, currentHighscoreCount.value);
		highscoreList.value = getChallengeFactory().createChallengeHighscoreEntryListByApiResponse(response.data);
	} catch (error: any | AxiosError) {
		const toast = await toastController.create({
			message: `Could not load challenge highscore!`,
			position: 'bottom',
			duration: 2000,
			icon: icons.warning,
			buttons: [
				{
					side: 'end',
					role: 'cancel',
					icon: icons.close
				}
			]
		});

		await toast.present();
	}
}

const getColorByRanking = function (ranking: number | any = null): string {
	switch (ranking) {
		case 1:
			return "success";
		case 2:
			return "warning";
		case 3:
			return "warning";
		default:
			return "medium";
	}
}


const getColorForProgressBar = function (progressPercentage: number): string {
	let color = 'tertiary';
	if (progressPercentage >= 1) {
		color = 'success';
	} else if (progressPercentage >= .8) {
		color = 'primary';
	} else if (progressPercentage >= .5) {
		color = 'secondary';
	}

	return color;
}

const isCurrentUser = function (email: string): boolean {
	return getUserEmail.value === email;
}


const loadMoreHighscoreData = (ev: InfiniteScrollCustomEvent) => {
	setTimeout(async () => {
		if (highscoreList.value.length <= currentHighscoreCount.value) {
			currentHighscoreCount.value += 25;
			await loadHighscore(props.uuid);
			await ev.target.complete();
		} else {
			ev.target.disabled = true;
		}
	}, 500);
}

onMounted(() => {
	loadHighscore(props.uuid);
});

watch(() => challengeFacade.getChallenge(props.uuid), async (newChallenge) => {
	if (props.uuid === newChallenge?.uuid) {
		await loadHighscore(props.uuid);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_unref(IonList), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonListHeader), null, {
          default: _withCtx(() => [
            _createTextVNode("Highscore")
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highscoreList.value, (highscoreEntry) => {
          return (_openBlock(), _createBlock(_unref(IonItem), {
            key: highscoreEntry.position,
            "is-current-user": isCurrentUser(highscoreEntry.user_email)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonBadge), {
                style: {"z-index":"9"},
                color: getColorByRanking(highscoreEntry.position),
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(highscoreEntry.position), 1)
                ]),
                _: 2
              }, 1032, ["color"]),
              _createVNode(_unref(IonAvatar), { slot: "start" }, {
                default: _withCtx(() => [
                  (highscoreEntry.user_avatar)
                    ? (_openBlock(), _createBlock(_unref(IonImg), {
                        key: 0,
                        src: highscoreEntry.user_avatar,
                        alt: highscoreEntry.user_avatar
                      }, null, 8, ["src", "alt"]))
                    : (_openBlock(), _createBlock(_unref(IonIcon), {
                        key: 1,
                        style: {"z-index":"8"},
                        icon: icons.personCircleOutline
                      }, null, 8, ["icon"]))
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createElementVNode("h2", null, _toDisplayString(highscoreEntry.user_name), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_2, [
                      _createElementVNode("span", null, _toDisplayString(highscoreEntry.progress) + "%", 1),
                      _withDirectives(_createVNode(_unref(IonIcon), {
                        icon: icons.checkmarkOutline,
                        style: {"margin-left":".25em"}
                      }, null, 8, ["icon"]), [
                        [_vShow, highscoreEntry.progress >= 100]
                      ])
                    ]),
                    _createVNode(_unref(IonProgressBar), {
                      color: getColorForProgressBar(highscoreEntry.getProgressPercentage()),
                      value: highscoreEntry.getProgressPercentage()
                    }, null, 8, ["color", "value"])
                  ]),
                  _createElementVNode("p", null, _toDisplayString(highscoreEntry.text), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["is-current-user"]))
        }), 128))
      ]),
      _: 1
    }, 512), [
      [_vShow, highscoreList.value.length > 0]
    ]),
    _withDirectives(_createVNode(_unref(IonItem), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonIcon), {
          size: "large",
          icon: icons.informationCircleOutline
        }, null, 8, ["icon"]),
        _createVNode(_unref(IonLabel), {
          class: "ion-text-wrap",
          style: {"margin-left":".5rem"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Es sind noch kein Einträge in der Highscore vorhanden! ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, highscoreList.value.length < 1]
    ]),
    _createVNode(_unref(IonInfiniteScroll), {
      onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (loadMoreHighscoreData($event))),
      threshold: "100px",
      id: "infinite-scroll"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonInfiniteScrollContent), {
          "loading-spinner": "dots",
          "loading-text": "Loading more highscores..."
        })
      ]),
      _: 1
    })
  ]))
}
}

})